import { MotifFormField, MotifInput, MotifLabel } from '@ey-xd/motif-react'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateExtraxtedText } from '../AnnotateSlice'
interface UserGroupProps {
  recordIndex: number
  evidenceId: string
  annotationTypeId?: string;
  personName: string
  userGroup: string
  permission: string
  pageNumber: number // Added 'pageNumber' property
  evidenceAnnotationId?: string
  originalRecord?: any
}
interface userGroup {
  personName: string
  userGroup: string
  permission: string
}

export const UserGroup: React.FC<UserGroupProps> = ({
  evidenceId,
  recordIndex,
  annotationTypeId,
  personName,
  userGroup,
  permission,
  pageNumber,
  evidenceAnnotationId,
  originalRecord,
}) => {
  const changed = (field: string, current: any) =>
    originalRecord != null && (current ?? '') !== (originalRecord[field] ?? '')
  const dispatch = useDispatch()
  const [userGroupDetails, setUserGroupDetails] = useState<userGroup>({
    personName: personName ? personName : '',
    userGroup: userGroup? userGroup : '',
    permission: permission? permission : '',
  })
  useEffect(() => {
    setUserGroupDetails({
      personName: personName ? personName : '',
      userGroup: userGroup ? userGroup : '',
      permission: permission ? permission : '',
    })
  }, [personName, userGroup, permission])
  const handleUserGroupChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setUserGroupDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }))
  }
  useEffect(() => {
    dispatch(
      updateExtraxtedText({
        evidenceId: evidenceId,
        recordIndex: recordIndex,
        annotationTypeId: annotationTypeId,
        extractedText: userGroupDetails,
        pageNumber: pageNumber ? pageNumber : 1, // Use the provided pageNumber or default to 1
        evidenceAnnotationId: evidenceAnnotationId,
      }),
    )
  }, [userGroupDetails])
  return (    <div className="user-detail-tab">
        <div className={changed('personName', userGroupDetails?.personName) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="name" position="in">
            Name
          </MotifLabel>
          <MotifInput
            id="personName"
            label="Name"
            name="personName"
            onChange={handleUserGroupChange}
            aria-label="name"
            labelPosition="in"
            value={userGroupDetails?.personName}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('userGroup', userGroupDetails?.userGroup) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel aria-label="group" position="in">
            Group
          </MotifLabel>
          <MotifInput
            id="group"
            name="userGroup"
            labelPosition="in"
            value={userGroupDetails?.userGroup}
            onChange={handleUserGroupChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
        <div className={changed('permission', userGroupDetails?.permission) ? 'field-changed' : ''}>
        <MotifFormField aria-label="Input" role="group">
          <MotifLabel
            aria-label="Permission"
            position="in"
          >
            Permission
          </MotifLabel>
          <MotifInput
            id="Permission"
            name="permission"
            labelPosition="in"
            value={userGroupDetails?.permission}
            onChange={handleUserGroupChange}
            hideClearButton
            autoComplete="off"
          />
        </MotifFormField>
        </div>
    </div>
  )
}
